(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ll-bed-review-samples"] && !Shopify.designMode) return;
  try {
    (()=>{
if(customElements.get('ll-bed-review-pages'))return;
class BedReviewPages extends HTMLElement{
 connectedCallback(){
  if(!this.initialized){this.initialized=true;this.limit=10;
  this.body=this.closest('.ll-feedback-body');this.status=this.body.querySelector('.ll-bed-review-status');
  this.samples=[...this.querySelectorAll('[data-ll-sample-review]')];this.button=this.querySelector('[data-ll-bed-more]');
  this.button.addEventListener('click',()=>{this.limit+=10;this.show();});}
  if(this.ready)return;this.observer?.disconnect();
  this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)&&this.getClientRects().length){this.observer.disconnect();this.load();}},{rootMargin:'120px'});this.observer.observe(this);
 }
 disconnectedCallback(){this.observer?.disconnect();}
 async load(){
  if(this.ready||this.loading)return;this.loading=true;
  const source=this.body.querySelector('ll-review-list');
  if(source){
   await customElements.whenDefined('ll-review-list');await source.load();
   if(!source.ready){this.status.textContent='Feedback could not load. Please refresh to try again.';this.loading=false;return;}
   while(source.shown<source.records.length)source.showMore();
  }
  const genuine=source?[...source.querySelectorAll('.ll-review-items>.ll-review-summary')]:[];
  this.rows=[];let g=0,s=0;
  const total=genuine.length+this.samples.length;
  for(let index=0;index<total;index++){
   const takeSample=s<this.samples.length&&(g>=genuine.length||Math.floor((index+1)*this.samples.length/total)>s);
   this.rows.push(takeSample?this.samples[s++]:genuine[g++]);
  }
  if(total!==Number(this.dataset.total)){this.status.textContent='Feedback could not load. Please refresh to try again.';this.loading=false;return;}
  this.list=source?source.list:document.createElement('div');this.list.className='ll-review-list';this.list.tabIndex=0;this.list.setAttribute('role','region');this.list.setAttribute('aria-label','Customer reviews and ratings');
  const items=source?source.items:document.createElement('div');items.className='ll-review-items';items.setAttribute('role','list');items.replaceChildren(...this.rows);source?.more.remove();if(!source)this.list.append(items);this.list.append(this.button);this.append(this.list);
  this.ready=true;this.loading=false;this.show();
 }
 show(){
  this.rows.forEach((row,i)=>row.hidden=i>=this.limit);
  const shown=Math.min(this.limit,this.rows.length),remaining=this.rows.length-shown;
  this.status.textContent='Showing '+shown+' of '+this.rows.length+' reviews';
  this.status.setAttribute('aria-label',shown+' of '+this.rows.length+' preview entries shown; '+this.dataset.sampleCount+' fictional samples included in total');
  this.button.hidden=remaining===0;this.button.textContent='Load more ('+Math.min(10,remaining)+')';
 }
}
customElements.define('ll-bed-review-pages',BedReviewPages);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ll-natural-floor-samples"] && !Shopify.designMode) return;
  try {
    (()=>{
if(customElements.get('ll-natural-review-pages'))return;
class NaturalReviewPages extends HTMLElement{
 connectedCallback(){
  if(!this.initialized){this.initialized=true;this.limit=10;this.button=this.querySelector('[data-ll-preview-more]');this.rows=[...this.querySelectorAll('[data-ll-sample-review]')];this.button.addEventListener('click',()=>{this.limit+=10;this.refresh();if(this.button.hidden){this.status.tabIndex=-1;this.status.focus({preventScroll:true});}});}
  this.body=this.closest('.ll-feedback-body');this.status=this.body.querySelector('.ll-natural-floor-preview-status');this.source=this.body.querySelector('ll-review-list');
  this.refresh();
  this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)&&this.getClientRects().length){this.observer.disconnect();this.loadSource();}},{rootMargin:'120px'});this.observer.observe(this);
 }
 disconnectedCallback(){this.observer?.disconnect();this.sourceObserver?.disconnect();}
 async loadSource(){
  if(this.source){await customElements.whenDefined('ll-review-list');this.sourceObserver?.disconnect();this.sourceObserver=new MutationObserver(()=>this.refresh());this.sourceObserver.observe(this.source,{childList:true,subtree:true});await this.source.load();}
  this.refresh();
 }
 refresh(){
  const genuine=this.source?.ready?this.source.records.length:Number(this.dataset.genuineCount),total=genuine+this.rows.length,budget=Math.max(0,this.limit-genuine);
  this.rows.forEach((row,index)=>{row.hidden=index>=budget;});
  const shown=Math.min(this.limit,total),remaining=total-shown;
  this.status.textContent='Showing '+shown+' of '+total+' reviews';this.status.setAttribute('aria-label',shown+' of '+total+' preview reviews shown, including fictional samples');
  this.button.hidden=remaining===0;this.button.textContent='Load more ('+Math.min(10,remaining)+')';
 }
}
customElements.define('ll-natural-review-pages',NaturalReviewPages);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ll-product-information"] && !Shopify.designMode) return;
  try {
    (()=>{
if(customElements.get('ll-product-information'))return;
class ProductInformation extends HTMLElement{
connectedCallback(){
 this.organise();
 if(!this.ready){this.observer=new MutationObserver(()=>this.organise());this.observer.observe(this,{childList:true,subtree:true});}
}
disconnectedCallback(){this.observer?.disconnect();}
organise(){
 if(this.ready)return;
 const source=this.querySelector('[data-ll-information-source]'),target=this.querySelector('[data-ll-delivery-target]');
 if(!source||!target)return;
 this.ready=true;this.observer?.disconnect();
 const heading=node=>{
  if(!(node instanceof HTMLElement))return null;
  if(/^H[2-6]$/.test(node.tagName))return node;
  const first=node.firstElementChild;
  return node.tagName==='P'&&first?.tagName==='STRONG'&&node.textContent.trim().startsWith(first.textContent.trim())&&/:\s*$/.test(first.textContent)?first:null;
 };
 const kind=label=>/^(?:delivery(?: and availability)?|estimated delivery|shipping|availability)$/i.test(label)?'delivery':/(?:installation|stability|safe use|safety|use.*care|^care$)/i.test(label)?'safety':'other';
 const groups=[];let active=null;
 for(const node of [...source.children]){
  const lead=heading(node);
  if(lead){active={kind:kind(lead.textContent.replace(/&/g,'and').replace(/:\s*$/,'').trim()),lead,nodes:[]};groups.push(active);}
  if(active)active.nodes.push(node);
 }
 for(const group of groups){
  if(group.kind==='delivery'){target.append(...group.nodes);continue;}
  if(group.kind!=='safety')continue;
  const details=document.createElement('details'),summary=document.createElement('summary'),copy=document.createElement('div');
  details.className='ll-safety-disclosure';copy.className='ll-copy';
  group.nodes[0].before(details);summary.append(group.lead);details.append(summary,copy);copy.append(...group.nodes.filter(n=>n!==group.lead));
  if(copy.firstElementChild?.tagName==='P'&&!copy.firstElementChild.textContent.trim())copy.firstElementChild.remove();
 }
 for(const item of [...source.querySelectorAll('li')]){
  const lead=item.firstElementChild;if(lead?.tagName!=='STRONG'||kind(lead.textContent.replace(/:\s*$/,'').trim())!=='delivery')continue;
  const list=document.createElement('ul');list.append(item);target.append(list);
 }
 for(const paragraph of [...source.children]){
  if(paragraph.tagName!=='P'||paragraph.children.length)continue;
  const marker='UK supplier delivery estimate:',at=paragraph.textContent.indexOf(marker);
  if(at<0)continue;
  const text=paragraph.textContent,delivery=document.createElement('p');paragraph.textContent=text.slice(0,at);delivery.textContent=text.slice(at);target.append(delivery);
  if(paragraph.textContent.trim()){
   const details=document.createElement('details'),summary=document.createElement('summary'),copy=document.createElement('div');
   details.className='ll-safety-disclosure';copy.className='ll-copy';summary.textContent=this.dataset.safetyLabel;paragraph.before(details);copy.append(paragraph);details.append(summary,copy);
  }else paragraph.remove();
 }
 for(const paragraph of [...source.querySelectorAll('p')]){
  if(!heading(paragraph)&&/Exact included accessories and delivery estimates are being checked\./.test(paragraph.textContent))target.append(paragraph);
 }
 const deliveryCopy=text=>text.replace(/The supplier normally dispatches/gi,'Orders normally dispatch').replace(/The supplier advertises/gi,'Estimated').replace(/The selected UK supplier estimates/gi,'Estimated delivery:').replace(/with the supplier/gi,'').replace(/(?:this|the|our) supplier[’']s UK warehouse/gi,'a UK warehouse').replace(/UK supplier delivery estimate:/gi,'UK delivery estimate:').replace(/\bsupplier[’']s\s+/gi,'').replace(/\bsupplier\s+/gi,'').replace(/\s+([.,;:])/g,'$1');
 const deliveryWalker=document.createTreeWalker(target,NodeFilter.SHOW_TEXT);let deliveryNode;while((deliveryNode=deliveryWalker.nextNode()))deliveryNode.textContent=deliveryCopy(deliveryNode.textContent);
 target.hidden=!target.children.length;
}
}
customElements.define('ll-product-information',ProductInformation);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ll-remaining-review-samples"] && !Shopify.designMode) return;
  try {
    (()=>{
if(customElements.get('ll-remaining-review-pages'))return;
class RemainingReviewPages extends HTMLElement{
 connectedCallback(){
  if(!this.initialized){this.initialized=true;this.limit=10;
  this.body=this.closest('.ll-feedback-body');this.status=this.body.querySelector('.ll-remaining-review-status');
  this.samples=[...this.querySelectorAll('[data-ll-sample-review]')];this.button=this.querySelector('[data-ll-remaining-more]');
  this.button.addEventListener('click',()=>{this.limit+=10;this.show();});}
  if(this.ready)return;this.observer?.disconnect();
  this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)&&this.getClientRects().length){this.observer.disconnect();this.load();}},{rootMargin:'120px'});this.observer.observe(this);
 }
 disconnectedCallback(){this.observer?.disconnect();}
 async load(){
  if(this.ready||this.loading)return;this.loading=true;
  const source=this.body.querySelector('ll-review-list');
  if(source){
   await customElements.whenDefined('ll-review-list');await source.load();
   if(!source.ready){this.status.textContent='Feedback could not load. Please refresh to try again.';this.loading=false;return;}
   while(source.shown<source.records.length)source.showMore();
  }
  const genuine=source?[...source.querySelectorAll('.ll-review-items>.ll-review-summary')]:[];
  this.rows=[];let g=0,s=0;
  const total=genuine.length+this.samples.length;
  for(let index=0;index<total;index++){
   const takeSample=s<this.samples.length&&(g>=genuine.length||Math.floor((index+1)*this.samples.length/total)>s);
   this.rows.push(takeSample?this.samples[s++]:genuine[g++]);
  }
  if(total!==Number(this.dataset.total)){this.status.textContent='Feedback could not load. Please refresh to try again.';this.loading=false;return;}
  this.list=source?source.list:document.createElement('div');this.list.className='ll-review-list';this.list.tabIndex=0;this.list.setAttribute('role','region');this.list.setAttribute('aria-label','Customer reviews and ratings');
  const items=source?source.items:document.createElement('div');items.className='ll-review-items';items.setAttribute('role','list');items.replaceChildren(...this.rows);source?.more.remove();if(!source)this.list.append(items);this.list.append(this.button);this.append(this.list);
  this.ready=true;this.loading=false;this.show();
 }
 show(){
  this.rows.forEach((row,i)=>row.hidden=i>=this.limit);
  const shown=Math.min(this.limit,this.rows.length),remaining=this.rows.length-shown;
  this.status.textContent='Showing '+shown+' of '+this.rows.length+' reviews';
  this.status.setAttribute('aria-label',shown+' of '+this.rows.length+' preview entries shown; '+this.dataset.sampleCount+' fictional samples included in total');
  this.button.hidden=remaining===0;this.button.textContent='Load more ('+Math.min(10,remaining)+')';
 }
}
customElements.define('ll-remaining-review-pages',RemainingReviewPages);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ll-review-text"] && !Shopify.designMode) return;
  try {
    (() => {
 if (customElements.get('ll-review-list')) return;
 const cache = new Map();
 const selectionCache = new Map();
 const reviewVideos = new Map([["temu-606559321068882-kim-macdonald-2026-06-23","https://rewvod-eu.kwcdn.com/review-video/4936649f2eba18472bba56a888db6f4daf70255d.f30.mp4"],["temu604209739081732|Av***as|Dec 3, 2025|5","https://rewvod-eu.kwcdn.com/review-video/11ba6a92de91872e302db2286bde74709ba997b2.f30.mp4"],["temu604209739081732|Mila Morozova|Jan 19, 2026|5","https://rewvod-eu.kwcdn.com/review-video/7c872888dbcbc5266733a537eda286da5f2c3152.f30.mp4"]]);
 const el = (tag, cls, text) => {
  const node = document.createElement(tag);
  if (cls) node.className = cls;
  if (text !== undefined && text !== null) node.textContent = text;
  return node;
 };
 const maskReviewAuthor = value => {
  let name = String(value || 'Customer').normalize('NFC').replace(/[\u0000-\u001f\u007f\u200e\u200f\u202a-\u202e\u2066-\u2069]/g, '').trim() || 'Customer';
  if (/amazon|aosom|temu|costway|wayfair|kaufland|shein|supplier|retailer/i.test(name)) name = 'Customer';
  if (/[*＊•]/u.test(name)) return name;
  const segmenter = typeof Intl.Segmenter === 'function' ? new Intl.Segmenter(undefined, {granularity:'grapheme'}) : null;
  return name.split(/\s+/u).map(word => {
   const letters = segmenter ? [...segmenter.segment(word)].map(part => part.segment) : Array.from(word);
   if (letters.length === 1) return letters[0] + '***';
   const visible = Math.ceil(letters.length / 2);
   return letters.slice(0, visible).join('') + '*'.repeat(letters.length - visible);
  }).join(' ');
 };
 const reviewDisplayText = value => String(value ?? '').replace(/\b(?:motherfuck(?:er|ers|ing)?|bullshit|horseshit|fuck(?:s|ed|er|ers|ing|in)?|shit(?:s|ty|ting|ted|head|heads)?|bitch(?:es|y|ing)?|bastard(?:s)?|cunt(?:s)?|(?:ass|arse)hole(?:s)?|dick(?:head)?s?|piss(?:ed|ing)?|bollocks|wanker(?:s)?|twat(?:s)?|crap(?:py)?|damn(?:ed)?|arse|ass)\b/gi, word => word.replace(/[a-z]/gi, '*'));
 const feedbackData = async url => {
  const response = await fetch(url);
  if (!response.ok) throw new Error('Feedback unavailable');
  if (!globalThis.crypto?.subtle) throw new Error('Feedback integrity unavailable');
  const bytes = await response.arrayBuffer();
  const digest = new Uint8Array(await globalThis.crypto.subtle.digest('SHA-256', bytes));
  const sha256 = Array.from(digest, byte => byte.toString(16).padStart(2, '0')).join('');
  const data = JSON.parse(new TextDecoder('utf-8', {fatal:true}).decode(bytes));
  if (data.parts) {
   if (!Array.isArray(data.parts) || !data.parts.length || data.parts.length > 20) throw new Error('Invalid feedback parts');
   const base = new URL(url, location.href);
   const parts = await Promise.all(data.parts.map(async name => {
    if (typeof name !== 'string' || !/^ll-feedback-v(?:18|19|20|21|22)-[a-z0-9-]+-part-\d+\.json$/.test(name)) throw new Error('Invalid feedback part name');
    const partUrl = new URL(name, base);
    if (partUrl.origin !== base.origin || partUrl.pathname.substring(0, partUrl.pathname.lastIndexOf('/')) !== base.pathname.substring(0, base.pathname.lastIndexOf('/'))) throw new Error('Invalid feedback part location');
    const partResponse = await fetch(partUrl.href);
    if (!partResponse.ok) throw new Error('Feedback part unavailable');
    const part = await partResponse.json();
    if (part.variantId !== data.variantId || part.pieceId !== data.pieceId || !Array.isArray(part.records) || part.records.length !== part.count) throw new Error('Invalid feedback part data');
    return part.records;
   }));
   data.records = parts.flat();
  }
  return {data, sha256};
 };
 const feedbackSelection = async url => {
  const response = await fetch(url);
  if (!response.ok) throw new Error('Feedback selection unavailable');
  const manifest = await response.json();
  if (!manifest || manifest.version !== 1 || !manifest.variants || typeof manifest.variants !== 'object' || Array.isArray(manifest.variants)) throw new Error('Invalid feedback selection');
  return manifest;
 };
 const selectFeedbackRecords = (entry, feedback, url, previewEnabled = false) => {
  if (!entry || typeof entry !== 'object' || Array.isArray(entry)) throw new Error('Missing feedback selection');
  const basename = decodeURIComponent(new URL(url, location.href).pathname.split('/').pop());
  if (typeof entry.source !== 'string' || !/^ll-feedback-[a-z0-9-]+\.json$/.test(entry.source) || entry.source !== basename) throw new Error('Invalid feedback selection source');
  if (typeof entry.sha256 !== 'string' || !/^[a-f0-9]{64}$/i.test(entry.sha256) || feedback.sha256 !== entry.sha256.toLowerCase()) throw new Error('Feedback selection integrity mismatch');
  const data = feedback.data;
  if (!Number.isSafeInteger(entry.count) || entry.count < 0 || entry.count !== data.count || !Array.isArray(data.records) || entry.count !== data.records.length) throw new Error('Feedback selection count mismatch');
  if (!Array.isArray(entry.indexes) || entry.indexes.length > entry.count || new Set(entry.indexes).size !== entry.indexes.length || entry.indexes.some(index => !Number.isSafeInteger(index) || index < 0 || index >= entry.count)) throw new Error('Invalid feedback selection indexes');
  let indexes = entry.indexes, limit = 15;
  if (previewEnabled && entry.preview !== undefined) {
   const preview = entry.preview;
   const plushScope = new Set(["55519505809737","55519505842505","55519437029705","55519505875273","55519505908041","55519437160777","55519437193545","55519437226313","55519437259081","55519437291849","55519437324617","55519437390153","55519437422921","55519437455689","55519437488457","55519505940809","55519437521225","55552153092425","55552153157961","55552153190729","55552153256265","55552153289033","55552153321801","55519619023177","55519619055945","55519619088713","55519619121481","55519619154249","55519619187017","55519619219785","55519619252553","55519619285321","55519619318089","55519619350857","55519619383625","55519619416393","55519619449161","55519619481929","55519619514697","55519619547465","55519619580233","55519619613001","55519619645769","55519619678537","55519619711305","55519619744073","55519619776841","55519619809609","55519619842377","55519619875145","55519620464969","55519620497737","55519620530505","55519620563273","55519619907913","55519619940681","55519619973449","55519620006217","55519620038985","55519620071753","55519620104521","55519620235593","55519620268361","55519620301129","55519620333897","55519620366665","55519620399433","55519620432201","55519620596041","55686302826825","55686302859593","55686302892361","55686302925129","55686302957897","55686302990665","55686303023433","55686303056201","55686303088969","55686303121737","55686303154505","55686303187273","55686303220041","55686303252809","55686303285577","55687028310345","55687028343113","55687028375881","55687028408649","55687028441417","55687028474185","55687028506953","55687028539721","55687028572489","55687028605257","55687028638025","55519620628809","55519620661577","55519620694345","55519620727113","55519618990409","55517877240137","55517877272905","55517877338441","55517877371209","55517877600585","55517877633353","55517877666121","55517877731657","55517877764425","55517877862729","55517877895497","55517878059337","55517878092105","55552827949385","55552827982153","55687041974601","55552825753929","55552825786697","55552825819465","55552825852233","55552825885001","55552825950537","55552825983305","55552826016073","55552826638665","55552826671433","55552826704201","55552826736969","55552827326793","55552827359561","55552827392329","55552827425097","55552827457865","55552827490633","55552827785545","55552827818313","55552828145993","55552828309833","55552828342601","55552828506441","55552828539209","55552828571977","55517876289865","55517876355401","55517876388169","55517876486473","55517876519241","55517876650313","55517876683081","55517876846921","55517876879689","55517876912457","55517877010761","55517877043529"]).has(String(data.variantId));
   if (!preview || typeof preview !== 'object' || Array.isArray(preview) || !Number.isSafeInteger(preview.limit) || preview.limit < (plushScope ? 0 : 20) || preview.limit > (plushScope ? 35 : 30)) throw new Error('Invalid preview review limit');
   if (preview.catalogueLabel !== undefined && typeof preview.catalogueLabel !== 'boolean') throw new Error('Invalid preview catalogue label');
   if (!Array.isArray(preview.indexes) || preview.indexes.length > preview.limit || new Set(preview.indexes).size !== preview.indexes.length || preview.indexes.some(index => !Number.isSafeInteger(index) || index < 0 || index >= entry.count || (!plushScope && !entry.indexes.includes(index)))) throw new Error('Invalid preview review indexes');
   if (preview.excluded !== undefined && (!Array.isArray(preview.excluded) || new Set(preview.excluded).size !== preview.excluded.length || preview.excluded.some(id => typeof id !== 'string' || !data.records.some(record => String(record.id) === id) || preview.indexes.some(index => String(data.records[index].id) === id)))) throw new Error('Invalid excluded preview reviews');
   indexes = preview.indexes;
   limit = preview.limit;
  }
  const selected = indexes.map(index => data.records[index]);
  if (selected.length <= limit) return selected;
  const priority = record => {
   const photos = reviewPhotos(record);
   const playableVideo = photos.some((photo, index) => photo && Array.isArray(record.mediaTypes) && record.mediaTypes[index] === 'video-preview' && reviewVideos.has(String(record.id)));
   if (playableVideo) return 0;
   return photos.some(Boolean) ? 1 : 2;
  };
  return selected.map((record, index) => ({record, index, priority:priority(record)}))
   .sort((left, right) => left.priority - right.priority || left.index - right.index)
   .slice(0, limit)
   .sort((left, right) => left.index - right.index)
   .map(entry => entry.record);
 };
 const feedbackPresentation = (entry, data, previewEnabled) => {
  const result = new Map();
  if (!previewEnabled || !entry.preview || entry.preview.presentation === undefined) return result;
  const edits = entry.preview.presentation;
  if (!edits || typeof edits !== 'object' || Array.isArray(edits) || Object.keys(edits).length > data.records.length) throw new Error('Invalid review presentation');
  for (const [id, edit] of Object.entries(edits)) {
   const matches = data.records.filter((record, index) => String(record.id) === id || (String(data.variantId) === '55519505875273' && !record.id && id === 'archive-index:' + index));
   if (matches.length !== 1 || !edit || typeof edit !== 'object' || Array.isArray(edit)) throw new Error('Invalid review presentation identity');
   const record = matches[0], originalPhotos = Array.isArray(record.i) ? record.i : [];
   if (Object.keys(edit).some(key => !['translation', 'omitPhotos', 'photoReplacements', 'simulation'].includes(key))) throw new Error('Invalid review presentation field');
   if (edit.simulation !== undefined) {
    const simulation = edit.simulation;
    if (!simulation || typeof simulation !== 'object' || Array.isArray(simulation) || Object.keys(simulation).some(key => !['originalRating', 'rating', 'text'].includes(key)) || simulation.originalRating !== record.s || !Number.isInteger(simulation.rating) || simulation.rating < 1 || simulation.rating > 5 || (simulation.text !== undefined && (record.q !== true || typeof simulation.text !== 'string' || !simulation.text.trim() || simulation.text.length > 10000))) throw new Error('Invalid simulated preview review');
   }
   if (edit.translation !== undefined) {
    const translation = edit.translation;
    if (!translation || typeof translation !== 'object' || Array.isArray(translation) || record.q !== true || translation.originalText !== record.t || typeof translation.text !== 'string' || !translation.text.trim() || translation.text.length > 10000 || !/^[a-z]{2}(?:-[A-Z]{2})?$/.test(translation.originalLanguage) || typeof translation.languageName !== 'string' || translation.languageName.length > 50) throw new Error('Invalid review translation');
   }
   if (edit.omitPhotos !== undefined && (!Array.isArray(edit.omitPhotos) || edit.omitPhotos.some(url => !originalPhotos.includes(url)))) throw new Error('Invalid omitted review photo');
   if (edit.photoReplacements !== undefined) {
    if (!edit.photoReplacements || typeof edit.photoReplacements !== 'object' || Array.isArray(edit.photoReplacements)) throw new Error('Invalid review photo replacements');
    for (const [url, replacement] of Object.entries(edit.photoReplacements)) {
     if (!originalPhotos.includes(url) || !reviewPhoto(replacement)) throw new Error('Invalid review photo replacement');
     const original = new URL(url), next = new URL(replacement);
     const verifiedWayfairPhoto = new Map([["https://assets.wfcdn.com/im/42101880/c_crop-h160-w160%5Ecompr-r25/4977/497780758/default_name.jpg","https://assets.wfcdn.com/im/42101880/resize-h1200-w1200%5Ecompr-r85/4977/497780758/default_name.jpg"],["https://assets.wfcdn.com/im/77857599/c_crop-h160-w160%5Ecompr-r25/4081/408151698/default_name.jpg","https://assets.wfcdn.com/im/77857599/resize-h1200-w1200%5Ecompr-r85/4081/408151698/default_name.jpg"],["https://assets.wfcdn.com/im/83844390/c_crop-h160-w160%5Ecompr-r25/3133/313308012/default_name.jpg","https://assets.wfcdn.com/im/83844390/resize-h1200-w1200%5Ecompr-r85/3133/313308012/default_name.jpg"]]).get(url) === replacement;
     const verifiedAmazonPhoto = new Map([["https://m.media-amazon.com/images/I/712Z0i-M4+L._SY88.jpg","https://m.media-amazon.com/images/I/712Z0i-M4+L.jpg"],["https://m.media-amazon.com/images/I/71UggOtRyrL._SY88.jpg","https://m.media-amazon.com/images/I/71UggOtRyrL.jpg"],["https://m.media-amazon.com/images/I/71AwdIxoMlL._SY88.jpg","https://m.media-amazon.com/images/I/71AwdIxoMlL.jpg"],["https://m.media-amazon.com/images/I/61bbwPnYiLL._SY88.jpg","https://m.media-amazon.com/images/I/61bbwPnYiLL.jpg"]]).get(url) === replacement;
     if (original.hostname !== next.hostname || (original.pathname !== next.pathname && !verifiedWayfairPhoto && !verifiedAmazonPhoto)) throw new Error('Mismatched review photo replacement');
    }
   }
   if ((edit.omitPhotos || edit.photoReplacements) && Array.isArray(record.mediaTypes) && record.mediaTypes.includes('video-preview')) throw new Error('Review video presentation cannot be reindexed');
   result.set(id, edit);
  }
  return result;
 };
 const source = (url) => {
  const parsed = new URL(url, location.href);
  if (parsed.protocol !== 'https:') throw new Error('Invalid source link');
  return parsed.href;
 };
 const reviewPhotoPaths = new Map([['rewimg-eu.kwcdn.com','/review-image/'],['rewimg-eu-2.kwcdn.com','/review-image/'],['media.cdn.kaufland.de','/product-reviews/'],['review-images.judgeme.com','/nuvido-nl/'],['review-images.judge.me',/^\/garvee\/[A-Za-z0-9_-]+__original\.(?:jpg|jpeg|png|webp)$/],['cdn.manomano.com','/media/ugc-customers-pictures/'],['assets.costway.com',/^\/media\/(?:c)?reviewimages\//],['cdn1.costway.com','/media/au/review/'],['au.costway.com','/media/review_images/'],['assets.wfcdn.com','/im/'],['m.media-amazon.com','/images/I/'],['images-na.ssl-images-amazon.com','/images/I/'],['target.scene7.com',/^\/is\/image\/Target\/GUEST_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/],['a.scdn.gr','/ds/skus/review_images/'],['b.scdn.gr','/ds/skus/review_images/'],['img.aosomcdn.com',/^\/(?:thumbnail\/)?\d+\/(?:n\d+\/)?\d+_comment\/\d{4}\/\d{2}\/\d{2}\//]]);
 const reviewPhoto = value => {
  if (typeof value !== 'string') return null;
  try {const u=new URL(value),prefix=reviewPhotoPaths.get(u.hostname);if(u.protocol!=='https:'||u.username||u.password||u.port||!prefix||!(prefix instanceof RegExp?prefix.test(u.pathname):u.pathname.startsWith(prefix)))return null;u.hash='';return u.href;} catch {return null;}
 };
 const reviewPhotos = record => {
  const photos=[],seenPhotoKeys=new Set();
  for(const url of [...new Set((Array.isArray(record.i)?record.i:[]).map(reviewPhoto).filter(Boolean))]){
   const u=new URL(url),key=/^rewimg-eu(?:-2)?\.kwcdn\.com$/.test(u.hostname)?u.pathname:url;
   if(seenPhotoKeys.has(key))continue;
   seenPhotoKeys.add(key);photos.push(url);
  }
  return photos;
 };
 class ReviewList extends HTMLElement {
  connectedCallback() {
   if (!this.initialized) {
    this.querySelectorAll('[data-review-generated]').forEach(node => node.remove());
    this.initialized = true;
   }
   this.visibilityObserver = new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting) && this.getClientRects().length) {
     this.visibilityObserver.disconnect();
     this.load();
    }
   }, {rootMargin:'120px'});
   this.visibilityObserver.observe(this);
  }
  disconnectedCallback() { this.visibilityObserver?.disconnect(); }
  async load() {
   if (this.ready || this.loading) return;
   this.loading = true;
   this.status = this.querySelector('.ll-review-status');
   this.status.textContent = 'Loading customer feedback…';
   this.querySelector('[data-review-retry]')?.remove();
   const url = this.dataset.url, selectionUrl = this.dataset.selectionUrl;
   try {
    if (!selectionUrl) throw new Error('Missing feedback selection URL');
    if (!selectionCache.has(selectionUrl)) selectionCache.set(selectionUrl, feedbackSelection(selectionUrl).catch(error => { selectionCache.delete(selectionUrl); throw error; }));
    if (!cache.has(url)) cache.set(url, feedbackData(url).catch(error => { cache.delete(url); throw error; }));
    const [manifest, feedback] = await Promise.all([selectionCache.get(selectionUrl), cache.get(url)]);
    const data = feedback.data;
    if (data.variantId !== this.dataset.variant || !Array.isArray(data.records) || !Array.isArray(data.sources) || data.records.length !== data.count) throw new Error('Invalid feedback data');
    const entry = Object.prototype.hasOwnProperty.call(manifest.variants, this.dataset.variant) ? manifest.variants[this.dataset.variant] : null;
    const previewEnabled = this.dataset.previewPresentation === 'true';
    const selected = selectFeedbackRecords(entry, feedback, url, previewEnabled);
    this.presentation = feedbackPresentation(entry, data, previewEnabled);
    this.catalogueLabel = previewEnabled && entry.preview?.catalogueLabel === true;
    for (const record of data.records) {
     if (!Number.isInteger(record.k) || !data.sources[record.k]) throw new Error('Invalid feedback source');
     source(data.sources[record.k].u);
    }
    this.records = selected.map(record => ({...record, ...data.sources[record.k], archiveIndex:data.records.indexOf(record)}));
    this.shown = 0;
    this.list = el('div', 'll-review-list');
    this.list.dataset.reviewGenerated = '';
    this.list.setAttribute('role', 'region');
    this.list.setAttribute('aria-label', 'Customer reviews and ratings');
    this.list.tabIndex = 0;
    this.more = el('button', 'll-review-load-more');
    this.more.dataset.reviewGenerated = '';
    this.more.type = 'button';
    this.more.addEventListener('click', () => this.showMore());
    this.items = el('div', 'll-review-items');
    this.items.setAttribute('role', 'list');
    this.list.append(this.items, this.more);
    this.append(this.list);
    let drag;
    this.list.addEventListener('pointerdown', event => {
     if (event.pointerType !== 'mouse' || event.button !== 0) return;
     drag = {id:event.pointerId,x:event.clientX,y:event.clientY,top:this.list.scrollTop,moved:false};
    });
    this.list.addEventListener('pointermove', event => {
     if (!drag || event.pointerId !== drag.id) return;
     const delta = event.clientY - drag.y;
     const deltaX = event.clientX - drag.x;
     if (!drag.moved && (Math.abs(delta) < 6 || Math.abs(delta) <= Math.abs(deltaX))) return;
     if (!drag.moved) this.list.setPointerCapture(event.pointerId);
     drag.moved = true;
     this.list.classList.add('is-dragging');
     this.list.scrollTop = drag.top - delta;
     event.preventDefault();
    });
    const finishDrag = () => {
     this.suppressClick = !!drag?.moved;
     drag = null;
     this.list.classList.remove('is-dragging');
     window.setTimeout(() => { this.suppressClick = false; }, 0);
    };
    this.list.addEventListener('pointerup', finishDrag);
    this.list.addEventListener('pointercancel', finishDrag);
    this.list.addEventListener('click', event => {
     if (this.suppressClick) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    this.showMore();
    this.ready = true;
   } catch (error) {
    this.ready = false;
    this.list?.remove();
    this.more?.remove();
    this.notice?.remove();
    cache.delete(url);
    selectionCache.delete(selectionUrl);
    this.status.textContent = 'Feedback could not load. Please refresh to try again.';

   } finally { this.loading = false; }
  }
  showMore() {
   const end = Math.min(this.shown + 10, this.records.length);
   const fragment = document.createDocumentFragment();
   for (const r of this.records.slice(this.shown, end)) {
    const presentation = this.presentation.get(String(r.id)) || (String(this.dataset.variant) === '55519505875273' ? this.presentation.get('archive-index:' + r.archiveIndex) : undefined) || {};
    const simulation = presentation.simulation;
    const displayRating = simulation ? simulation.rating : r.s;
    const article = el('article', 'll-review-summary');
    article.setAttribute('role', 'listitem');
    if (r.id != null && r.id !== '') article.dataset.reviewId = String(r.id);
    const customerContent = article;
    const meta = el('p', 'll-review-meta');
    meta.append(el('strong', '', maskReviewAuthor(r.a)));
    if (Number.isFinite(displayRating) && displayRating >= 1 && displayRating <= 5) {
     const stars = el('div', 'll-review-individual-stars');
     stars.setAttribute('role', 'img');
     stars.setAttribute('aria-label', (simulation ? this.dataset.editedRatingLabel + '; ' : '') + this.dataset.starsLabel.replace('__rating__', displayRating));
     const starRow = el('span', 'll-rating-stars');
     starRow.setAttribute('aria-hidden', 'true');
     starRow.style.setProperty('--ll-rating-fill', (displayRating * 20) + '%');
     for (const name of ['ll-rating-outlines', 'll-rating-filled']) {
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 100 20');
      svg.setAttribute('focusable', 'false');
      svg.setAttribute('class', name);
      for (let index = 0; index < 5; index++) {
       const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
       path.setAttribute('d', 'm10 2 2.47 5.01 5.53.8-4 3.9.94 5.51L10 14.62l-4.94 2.6L6 11.71l-4-3.9 5.53-.8Z');
       path.setAttribute('transform', 'translate(' + (index * 20) + ' 0)');
       svg.append(path);
      }
      starRow.append(svg);
     }
     const number = el('span', 'll-review-rating-number', displayRating + '/5');
     number.setAttribute('aria-hidden', 'true');
     stars.append(starRow, number);
     article.append(stars);
    }
    if (r.d) {
     if (meta.childNodes.length) meta.append(document.createTextNode(' · '));
     if (/^\d{4}-\d{2}-\d{2}$/.test(r.d)) {
      const time = el('time', '', new Date(r.d + 'T12:00:00Z').toLocaleDateString('en-GB', {day:'numeric', month:'short', year:'numeric', timeZone:'UTC'}));
      time.dateTime = r.d;
      meta.append(time);
     } else meta.append(document.createTextNode(r.d));
    }
    const product = (this.dataset.reviewProduct || '').split(/\s+[—–]\s+/u)[0].trim();
    const option = String(r.p || '').replace(/(?:Colour|Color)(?:\s*Name)?:\s*/gi, '').replace(/Size(?:\s*Name)?:\s*/gi, ' · ').replace(/^(?:Purchased|Option):\s*/i, '').replace(/\s+/g, ' ').trim();
    const purchased = this.catalogueLabel ? (this.dataset.reviewProduct || '').trim() : [product, option].filter(Boolean).join(' — ');
    if (purchased) {
     article.append(el('p', 'll-review-purchased', purchased));
    }
    if (simulation?.text) article.append(el('p', 'll-review-body-text', reviewDisplayText(simulation.text)));
    if (!simulation) customerContent.append(meta);
    if (!simulation && r.originalTitle) customerContent.append(el('p', 'll-review-original-title', reviewDisplayText(r.originalTitle)));
    if (!simulation && r.t && r.q === true) {
     if (presentation.translation) {
      const translation = presentation.translation;
      const translatedBody = el('p', 'll-review-body-text', reviewDisplayText(translation.text));
      translatedBody.lang = 'en';
      translatedBody.dataset.originalLanguage = translation.originalLanguage;
      customerContent.append(translatedBody);
     } else customerContent.append(el('p', 'll-review-body-text', reviewDisplayText(r.t)));
    }
    if (r.disclosure) customerContent.append(el('p', 'll-review-disclosure', r.disclosure));
    const photos = reviewPhotos({...r, i:(Array.isArray(r.i) ? r.i : []).filter(url => !presentation.omitPhotos?.includes(url)).map(url => presentation.photoReplacements?.[url] || url)});
    if(photos.length){
     const figure=el('figure','ll-review-attachments'),grid=el('div','ll-review-photo-grid');
     grid.setAttribute('role','group');grid.setAttribute('aria-label','Customer review attachments');
     photos.forEach((url,index)=>{
      const preview = Array.isArray(r.mediaTypes) && r.mediaTypes[index] === 'video-preview';
      const video = preview ? reviewVideos.get(String(r.id)) : null;
      const link=el('button','ll-review-photo-link');link.type='button';link.dataset.llReviewMedia=video||url;link.dataset.llReviewKind=video?'video':'image';link.dataset.llReviewZoomHint=this.dataset.reviewZoomHint;
      link.setAttribute('aria-label',(video?'Play customer review video ': 'Enlarge customer review '+(preview?'video preview':'photo')+' ')+(index+1));
      link.dataset.llReviewAlt='Customer review '+(video?'video':preview?'video preview image':'photo')+' '+(index+1);
      const img=el('img');img.draggable=false;img.alt='Customer review attachment '+(index+1);img.width=96;img.height=96;img.loading='lazy';img.decoding='async';img.referrerPolicy='no-referrer';
      img.addEventListener('error',()=>{link.remove();if(!grid.childElementCount)figure.remove();},{once:true});
      img.src=url;link.append(img);grid.append(link);
     });
     if (simulation) {
      const credit = el('figcaption', 'll-review-photo-credit');
      credit.append(...meta.childNodes);
      figure.append(credit);
     }
     figure.append(grid);customerContent.append(figure);
    }
    fragment.append(article);
   }
   this.items.append(fragment);
   this.shown = end;
   const remaining = this.records.length - this.shown;
   this.more.hidden = remaining === 0;
   const batchSize = Math.min(10, remaining);
   this.more.textContent = this.dataset.loadMore + ' (' + batchSize + ')';
   this.status.textContent = 'Showing ' + this.shown + (this.shown < this.records.length ? ' of ' + this.records.length : '') + (this.records.length === 1 ? ' selected review or rating.' : ' selected reviews and ratings.');
  }
 }
 customElements.define('ll-review-list', ReviewList);
})();
  } catch(e) { console.error(e); }
})();

})();
